import { Component, input } from '@angular/core';
import { FloatMessageComponent, messageImports } from './float-message.component';

@Component({
    selector: 'app-info-float-message',
    templateUrl: 'float-message.component.html',
    styleUrls: ['./float-message.component.scss'],
    imports: messageImports,
})
export class InfoFloatMessageComponent extends FloatMessageComponent {
    public override severity = input<'success' | 'info' | 'warn' | 'error'>('info');
}
